<template>

    <div>
        
        <div class="container-fluid">
             <div class="row">
                <div class="col-md-10 m-auto">
                    <table class="table table-lg table-borderless text-center font-weight-normal ">
                    <tr class="col-md-10 m-auto" v-for="invitation in mesInvitations.invitations" :key="invitation.id">
                        <role-Confirmation :invitation="invitation" :user="mesInvitations.user" @AccepterRefuser="AccepterRefuserInvitation">

                        </role-Confirmation>
                    </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>

    import api from "../../config/_api";
    import RoleConfirmation from "./RoleConfirmation.vue";
    
    import { mapGetters } from 'vuex';
    

export default {
        name: "Role",
        components: {
            'role-Confirmation' : RoleConfirmation
        },
        data() {
            return {
                error:false,
                errormsg:"",
                action : "",

            }
             
        },
        computed : {
            ...mapGetters({
               mesInvitations: 'adherents/mesInvitations',
            }),
        },
    created() {
        this.token=this.$route.params.token;
        this.$store.dispatch('adherents/getRoleInvitations');
    },
        methods : {
            AccepterRefuserInvitation(value){
                this.action=value.action;
                this.error=value.error;
                this.$store.dispatch('adherents/getRoleInvitations');
                this.$emit('AccepterRefuser');
            },
        }
    
}
</script>